module.exports = __webpack_public_path__ + "img/4 v&p tied.8fbdb6ce.png";